export function getHTML(text) {
    if(text){
        const result = text.replace(/<[^>]+>/g, ' ');
        return result;
    }else{
        return ""
    }
  
}
